export enum InvoiceCreationType {
    MANUAL = 'MANUAL',
    DELIVERY_NOTE = 'DELIVERY_NOTE',
}
